import React, { Component } from "react";
import Modal from 'react-responsive-modal';
import { promotionalVariable, variableMap, allTransactionalVariables } from "./integartionHelper";
import {
  FiUpload,
  FiX,
  FiMusic,
  FiImage,
  FiVideo,
  FiFile,
} from "react-icons/fi";
import Spinner from "../../../Common/Spinner";

const MAX_CHARS = 1024;

const extractVariablesFromContent = (content) => {
  const regex = /{{(.*?)}}/g;
  const variables = new Set();
  let match;
  while ((match = regex.exec(content))) {
    variables.add(match[1]);
  }
  return Array.from(variables);
};

const getAvailableVariables = (category, eventName, templateType) => {
  if (templateType !== "transactional") {
    return promotionalVariable;
  }

  const catEntry = variableMap[category];

  if (!catEntry) return [];

  if (Array.isArray(catEntry)) {
    return catEntry;
  }

  if (typeof catEntry === "object") {
    if (eventName && catEntry.hasOwnProperty(eventName)) {
      return catEntry[eventName];
    }
    return [];
  }

  return [];
};

const getMediaIcon = (type) => {
  switch (type) {
    case "image":
      return <FiImage className="text-2xl" />;
    case "video":
      return <FiVideo className="text-2xl" />;
    case "audio":
      return <FiMusic className="text-2xl" />;
    case "document":
      return <FiFile className="text-2xl" />;
    default:
      return <FiFile className="text-2xl" />;
  }
};

class TemplateFormModal extends Component {
  constructor(props) {
    super(props);
    this.messageContentRef = React.createRef();
    this.fileInputRef = React.createRef();
    
    // Initialize state from props
    this.state = this.getStateFromProps(props);
  }

  // Helper method to extract state from props
  getStateFromProps(props) {
    const initialData = props.initialData || {};
    console.log("Getting state from props:", initialData);
    
    return {
      templateForm: {
        _id: initialData._id || null,
        templateId: initialData.templateId || "",
        name: initialData.name || "",
        category: initialData.category || "",
        content: initialData.content || "",
        variables: initialData.variables || [],
        eventName: initialData.eventName || "",
        isSetupDone: initialData.isSetupDone || false,
        media: initialData.media || { type: "", url: "", filename: "" },
        variableMappings: initialData.variableMappings || {},
        manualVariables: initialData.manualVariables || []
      },
      formErrors: {},
      isUploading: false,
      activeVariableTab: "dynamic",
      availableVariables: []
    };
  }

  // Use getDerivedStateFromProps to handle prop updates
  static getDerivedStateFromProps(nextProps, prevState) {
    // When modal opens or initialData changes, update the form
    if (nextProps.isOpen && nextProps.initialData) {
      const initialData = nextProps.initialData;
      // const currentId = prevState.templateForm._id;
      // const newId = initialData._id;
      // Fall back to templateId: predefined (not-yet-setup) templates have no _id yet,
      // so comparing _id alone compares null (state default) to undefined (missing prop),
      // which are never equal and forces a reset on every keystroke.
      const currentId = prevState.templateForm._id || prevState.templateForm.templateId;
      const newId = initialData._id || initialData.templateId;

      // Only update if the data is different or modal just opened with new data
      if (currentId !== newId) {
        console.log("Updating form with new data:", initialData);
        return {
          templateForm: {
            _id: initialData._id || null,
            templateId: initialData.templateId || "",
            name: initialData.name || "",
            category: initialData.category || "",
            content: initialData.content || "",
            variables: initialData.variables || [],
            eventName: initialData.eventName || "",
            isSetupDone: initialData.isSetupDone || false,
            media: initialData.media || { type: "", url: "", filename: "" },
            variableMappings: initialData.variableMappings || {},
            manualVariables: initialData.manualVariables || []
          },
          formErrors: {}
        };
      }
    }
    return null;
  }

  componentDidMount() {
    console.log("Component mounted with initialData:", this.props.initialData);
    this.fetchVariables();
  }

  componentDidUpdate(prevProps, prevState) {
    // Fetch variables when event name changes
    const prevEventName = prevState.templateForm && prevState.templateForm.eventName;
    const currentEventName = this.state.templateForm && this.state.templateForm.eventName;
    
    if (prevEventName !== currentEventName) {
      this.fetchVariables();
    }
  }

  fetchVariables = async () => {
    const { templateType } = this.props;
    const { templateForm } = this.state;
    
    console.log("Fetching variables for event:", templateForm.eventName);
     if (templateType === "promotional") {
        this.setState({ availableVariables:promotionalVariable});
      return;
    }
    if (templateType !== "transactional" || !templateForm.eventName) {
      this.setState({ availableVariables: [] });
      return;
    }

    try {
      const response = await this.props.getEventVariables(templateForm.eventName);
      console.log("Response from getEventVariables:", response);
      if (response.code === "0") {
        const vars = response.data || [];
        const mappedVars = vars.map(v => {
          if (typeof v === 'object') return v;
          const found = allTransactionalVariables.find(tv => tv.value === v);
          return found || { 
            label: v.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()), 
            value: v 
          };
        });
        this.setState({ availableVariables: mappedVars });
      }
    } catch (error) {
      console.error("Failed to fetch variables:", error);
    }
  };

  // Rest of your existing methods (handleFormChange, handleMediaChange, etc.) remain the same
  handleFormChange = (e) => {
    const { name, value } = e.target;
    const newFormErrors = Object.assign({}, this.state.formErrors);
    delete newFormErrors[name];
    
    this.setState({
      templateForm: Object.assign({}, this.state.templateForm, { [name]: value }),
      formErrors: newFormErrors
    });
  };

  handleMediaChange = (e) => {
    const { name, value } = e.target;
    const field = name.split(".")[1];
    const newMedia = Object.assign({}, this.state.templateForm.media, { [field]: value });
    const newTemplateForm = Object.assign({}, this.state.templateForm, { media: newMedia });
    
    const newFormErrors = Object.assign({}, this.state.formErrors);
    delete newFormErrors[`media${field.charAt(0).toUpperCase() + field.slice(1)}`];
    
    this.setState({
      templateForm: newTemplateForm,
      formErrors: newFormErrors
    });
  };

  getExtractedVariables = () => {
    const regex = /{{(\d+)}}/g;
    const vars = new Set();
    let match;
    const content = this.state.templateForm.content || "";
    while ((match = regex.exec(content))) {
      vars.add(parseInt(match[1], 10));
    }
    return Array.from(vars);
  };

  getAllVariables = () => {
    const extractedVariables = this.getExtractedVariables();
    const manual = this.state.templateForm.manualVariables || [];
    const combined = new Set([...extractedVariables, ...manual]);
    return Array.from(combined).sort((a, b) => a - b);
  };

  handleAddVariable = () => {
    const allVariables = this.getAllVariables();
    const currentMax = allVariables.length > 0 ? Math.max(...allVariables) : 0;
    const nextVar = currentMax + 1;
    const variableText = `{{${nextVar}}}`;

    const textarea = this.messageContentRef.current;
    let newContent = this.state.templateForm.content || "";

    if (textarea) {
      const start = textarea.selectionStart || 0;
      const end = textarea.selectionEnd || 0;
      const text = textarea.value || "";

      newContent = text.substring(0, start) + variableText + text.substring(end);

      setTimeout(() => {
        if (this.messageContentRef.current) {
          this.messageContentRef.current.focus();
          this.messageContentRef.current.selectionStart = start + variableText.length;
          this.messageContentRef.current.selectionEnd = start + variableText.length;
        }
      }, 0);
    } else {
      newContent = newContent + variableText;
    }

    const newManualVariables = (this.state.templateForm.manualVariables || []).concat([nextVar]);
    
    this.setState({
      templateForm: Object.assign({}, this.state.templateForm, {
        content: newContent,
        manualVariables: newManualVariables
      })
    });
  };

  handleRemoveVariable = (varNum) => {
    const newManualVariables = this.state.templateForm.manualVariables.filter(v => v !== varNum);
    this.setState({
      templateForm: Object.assign({}, this.state.templateForm, {
        manualVariables: newManualVariables
      })
    });
  };

  handleMappingChange = (varNum, field, value) => {
    const currentMappings = this.state.templateForm.variableMappings || {};
    const currentMapping = currentMappings[varNum] || { type: "dynamic", value: "" };
    const newMapping = Object.assign({}, currentMapping, { [field]: value });
    const newMappings = Object.assign({}, currentMappings, { [varNum]: newMapping });
    
    this.setState({
      templateForm: Object.assign({}, this.state.templateForm, {
        variableMappings: newMappings
      })
    });
  };

  copyVariableToClipboard = (varNum) => {
    const text = `{{${varNum}}}`;
    navigator.clipboard.writeText(text);
  };

  handleImageUpload = async (image) => {
    let url;
    let fileName = +new Date().getTime() + image.name;
    await this.props
      .uploadFileToServer(
        image,
        this.props.registration.registration.StorageFolder +
          "/WhatsAppTemplate",
        fileName
      )
      .then((downloadURL) => {
        let bucket = "posible.in/";
        let folder =
          this.props.registration.registration.StorageFolder +
          "/WhatsAppTemplate/";
        url =
          "https://storage.googleapis.com/" + bucket + folder + fileName;
      });
    return url;
  };

  handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = {
      image: ["image/jpeg", "image/png", "image/gif"],
      video: ["video/mp4", "video/quicktime"],
      audio: ["audio/mpeg", "audio/wav", "audio/ogg"],
      document: [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ],
    };

    let actualType = "";
    const entries = Object.entries(validTypes);
    for (let i = 0; i < entries.length; i++) {
      const [key, values] = entries[i];
      if (values.indexOf(file.type) !== -1) {
        actualType = key;
        break;
      }
    }

    const selectedType = this.state.templateForm.media && this.state.templateForm.media.type;

    if (!actualType) {
      const newFormErrors = Object.assign({}, this.state.formErrors);
      newFormErrors.mediaType = "Unsupported file type";
      this.setState({ formErrors: newFormErrors });
      return;
    }

    if (selectedType && actualType !== selectedType) {
      const newFormErrors = Object.assign({}, this.state.formErrors);
      newFormErrors.mediaType = `Selected type is "${selectedType}", but uploaded file is of type "${actualType}".`;
      this.setState({ formErrors: newFormErrors });
      return;
    }

    this.setState({ isUploading: true });
    try {
      const uploadedUrl = await this.handleImageUpload(file);
      const newMedia = Object.assign({}, this.state.templateForm.media, {
        type: actualType,
        url: uploadedUrl,
        filename: file.name,
      });
      const newTemplateForm = Object.assign({}, this.state.templateForm, { media: newMedia });
      
      const newFormErrors = Object.assign({}, this.state.formErrors);
      delete newFormErrors.mediaType;
      delete newFormErrors.mediaUrl;
      delete newFormErrors.mediaFilename;
      
      this.setState({
        templateForm: newTemplateForm,
        formErrors: newFormErrors
      });
    } catch (error) {
      const newFormErrors = Object.assign({}, this.state.formErrors);
      newFormErrors.mediaUrl = "Failed to upload file";
      this.setState({ formErrors: newFormErrors });
    } finally {
      this.setState({ isUploading: false });
    }
  };

  handleRemoveMedia = () => {
    this.setState({
      templateForm: Object.assign({}, this.state.templateForm, {
        media: { type: "", url: "", filename: "" }
      })
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const errors = {};
    const { templateForm } = this.state;
    const { templateType, onSubmit } = this.props;
    
    if (!templateForm.name || templateForm.name.trim() === "") {
      errors.name = "Template name is required";
    }
    if (!templateForm.content || templateForm.content.trim() === "") {
      errors.content = "Message content is required";
    }

    if (templateType === "promotional") {
      const hasMediaType = templateForm.media && templateForm.media.type;
      const hasMediaUrl = templateForm.media && templateForm.media.url;
      const hasMediaFilename = templateForm.media && templateForm.media.filename;
      
      if (hasMediaType || hasMediaUrl || hasMediaFilename) {
        if (!templateForm.media || !templateForm.media.type) {
          errors.mediaType = "Media type is required if other media fields are provided";
        }
        if (!templateForm.media || !templateForm.media.url) {
          errors.mediaUrl = "Media URL is required if other media fields are provided";
        }
        if (!templateForm.media || !templateForm.media.filename) {
          errors.mediaFilename = "Media filename is required if other media fields are provided";
        }
        if (templateForm.media && templateForm.media.type && ["image", "video", "audio", "document"].indexOf(templateForm.media.type) === -1) {
          errors.mediaType = "Invalid media type";
        }
      }
    }

    const errorKeys = Object.keys(errors);
    if (errorKeys.length > 0) {
      this.setState({ formErrors: errors });
      return;
    }

    if (templateType === "transactional") {
      const allVariables = this.getAllVariables();
      const unmapped = [];
      
      for (let i = 0; i < allVariables.length; i++) {
        const varNum = allVariables[i];
        const mapping = templateForm.variableMappings && templateForm.variableMappings[varNum];
        if (!mapping || !mapping.value || mapping.value.toString().trim() === "") {
          unmapped.push(varNum);
        }
      }

      if (unmapped.length > 0) {
        const newErrors = Object.assign({}, errors);
        newErrors.variables = `Please map the following variables: ${unmapped.map(v => `{{${v}}}`).join(", ")}`;
        this.setState({ formErrors: newErrors });
        return;
      }
    }

    const mediaToSend = (templateType === "promotional" && 
      templateForm.media && 
      templateForm.media.type && 
      templateForm.media.url && 
      templateForm.media.filename) ? templateForm.media : undefined;

    onSubmit({
      ...templateForm,
      variables: this.getAllVariables().map(v => v.toString()),
      variableMappings: templateForm.variableMappings,
      manualVariables: templateForm.manualVariables,
      media: mediaToSend
    });
  };

  render() {
    const { isOpen, onClose, templateType, loading } = this.props;
    const { templateForm, formErrors, isUploading, availableVariables } = this.state;
    
    // Add debug log to see what data is being rendered
    console.log("Rendering modal with templateForm:", templateForm);
    
    const extractedVariables = this.getExtractedVariables();
    const allVariables = this.getAllVariables();

    const styles = {
      modalContent: {
        width: "90vw",
        maxWidth: "1200px",
        padding: "0",
        borderRadius: "12px"
      },
      modalHeader: {
        padding: "20px 24px",
        borderBottom: "1px solid #e5e7eb",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      },
      modalTitle: {
        fontSize: "20px",
        fontWeight: "600",
        color: "#1f2937",
        margin: 0
      },
      closeButton: {
        background: "none",
        border: "none",
        fontSize: "24px",
        cursor: "pointer",
        color: "#6b7280"
      },
      modalBody: {
        padding: "24px",
        maxHeight: "70vh",
        overflowY: "auto"
      },
      modalFooter: {
        padding: "16px 24px",
        borderTop: "1px solid #e5e7eb",
        display: "flex",
        justifyContent: "flex-end",
        gap: "12px"
      },
      saveButton: {
        padding: "8px 20px",
        backgroundColor: "#2563eb",
        color: "#ffffff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "500"
      },
      cancelButton: {
        padding: "8px 20px",
        backgroundColor: "#f3f4f6",
        color: "#374151",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "500"
      },
      formContainer: {
        display: "flex",
        position: "relative"
      },
      leftColumn: {
        paddingRight: "24px",
        width: "66.666%",
        overflowX: "auto"
      },
      formGroup: {
        marginBottom: "12px"
      },
      flexRow: {
        display: "flex",
        gap: "24px",
        marginBottom: "12px"
      },
      inputGroup: {
        flex: 1
      },
      label: {
        display: "block",
        fontSize: "14px",
        fontWeight: "500",
        color: "#374151",
        marginBottom: "8px"
      },
      input: {
        width: "100%",
        padding: "4px 16px",
        border: "1px solid #d1d5db",
        borderRadius: "8px",
        fontSize: "14px"
      },
      inputError: {
        borderColor: "#ef4444"
      },
      errorText: {
        color: "#ef4444",
        fontSize: "14px",
        marginTop: "4px"
      },
      textarea: {
        width: "100%",
        padding: "12px 16px",
        border: "1px solid #d1d5db",
        borderRadius: "8px",
        resize: "vertical",
        fontSize: "14px",
        fontFamily: "monospace"
      },
      variableBox: {
        backgroundColor: "#f9fafb",
        padding: "16px",
        borderRadius: "8px",
        border: "1px solid #e5e7eb",
        marginTop: "16px"
      },
      variableHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "12px"
      },
      sectionTitle: {
        fontWeight: "600",
        color: "#374151"
      },
      addButton: {
        padding: "4px 12px",
        backgroundColor: "#2563eb",
        color: "#ffffff",
        fontSize: "14px",
        borderRadius: "4px",
        border: "none",
        cursor: "pointer"
      },
      variableItem: {
        marginBottom: "12px",
        padding: "12px",
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: "8px"
      },
      variableRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "8px"
      },
      variableCode: {
        fontFamily: "monospace",
        fontWeight: "bold",
        color: "#2563eb",
        backgroundColor: "#eff6ff",
        padding: "4px 8px",
        borderRadius: "4px",
        cursor: "pointer"
      },
      removeButton: {
        color: "#f87171",
        background: "none",
        border: "none",
        cursor: "pointer"
      },
      select: {
        width: "100%",
        padding: "8px 12px",
        border: "1px solid #d1d5db",
        borderRadius: "4px",
        fontSize: "14px",
        backgroundColor: "#f9fafb"
      },
      staticInputContainer: {
        position: "relative",
        display: "flex",
        alignItems: "center"
      },
      staticInput: {
        width: "100%",
        padding: "8px 12px",
        paddingRight: "32px",
        border: "1px solid #d1d5db",
        borderRadius: "4px",
        fontSize: "14px"
      },
      clearButton: {
        position: "absolute",
        right: "8px",
        background: "none",
        border: "none",
        color: "#9ca3af",
        cursor: "pointer"
      },
      errorAlert: {
        marginTop: "12px",
        padding: "12px",
        backgroundColor: "#fef2f2",
        border: "1px solid #fecaca",
        borderRadius: "4px",
        fontSize: "14px",
        color: "#dc2626"
      },
      rightColumn: {
        width: "50%",
        paddingLeft: "24px",
        borderLeft: "1px solid #e5e7eb",
        position: "sticky",
        top: 0,
        overflowY: "auto"
      },
      previewTitle: {
        fontSize: "20px",
        fontWeight: "600",
        color: "#1f2937",
        marginBottom: "16px"
      },
      labelBubble: {
        backgroundColor: "#10b981",
        color: "#ffffff",
        padding: "8px 16px",
        borderRadius: "12px",
        borderTopLeftRadius: 0,
        maxWidth: "fit-content",
        alignSelf: "flex-start",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)"
      },
      labelText: {
        fontWeight: "600",
        fontSize: "14px"
      },
      previewBubble: {
        backgroundColor: "#d1fae5",
        padding: "16px",
        borderRadius: "12px",
        width: "100%",
        alignSelf: "flex-start",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)"
      },
      mediaPreview: {
        marginBottom: "8px"
      },
      image: {
        borderRadius: "8px",
        maxWidth: "100%"
      },
      video: {
        borderRadius: "8px",
        maxWidth: "100%"
      },
      audio: {
        width: "100%"
      },
      documentPreview: {
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        padding: "8px"
      },
      documentIcon: {
        backgroundColor: "#eff6ff",
        color: "#2563eb",
        padding: "8px",
        borderRadius: "8px"
      },
      documentContent: {
        flex: 1,
        minWidth: 0
      },
      documentTitle: {
        fontSize: "14px",
        fontWeight: "500",
        color: "#374151"
      },
      documentType: {
        fontSize: "12px",
        color: "#6b7280"
      },
      documentLink: {
        fontSize: "12px",
        color: "#2563eb",
        textDecoration: "none"
      },
      messageText: {
        color: "#1f2937",
        whiteSpace: "pre-wrap",
        fontSize: "14px",
        lineHeight: "1.625"
      },
      emptyPreview: {
        color: "#9ca3af",
        fontSize: "14px",
        fontStyle: "italic"
      },
      errorSummary: {
        backgroundColor: "#fef2f2",
        border: "1px solid #fecaca",
        borderRadius: "8px",
        padding: "16px",
        marginTop: "24px"
      },
      errorSummaryTitle: {
        fontSize: "18px",
        fontWeight: "600",
        color: "#991b1b"
      },
      errorList: {
        listStyle: "disc",
        listStylePosition: "inside",
        color: "#b91c1c",
        marginTop: "4px"
      },
      errorItem: {
        fontSize: "14px"
      },
      uploadButton: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "12px 16px",
        backgroundColor: "#eff6ff",
        color: "#2563eb",
        borderRadius: "8px",
        border: "1px solid #bfdbfe",
        cursor: "pointer",
        marginTop: "24px"
      },
      mediaUrlRow: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        marginTop: "12px"
      },
      mediaUrlContainer: {
        flex: 1
      },
      removeMediaButton: {
        marginTop: "24px",
        color: "#9ca3af",
        background: "none",
        border: "none",
        cursor: "pointer"
      },
      uploadLoader: {
        backgroundColor: "#eff6ff",
        color: "#1d4ed8",
        padding: "12px",
        borderRadius: "8px",
        marginTop: "8px"
      },
      previewContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "8px"
      }
    };

    return (
      <Modal
        open={isOpen}
        onClose={onClose}
        center={true}
        styles={{
          modal: {
            maxWidth: "90vw",
            width: "90vw",
            padding: 0,
            borderRadius: "12px"
          }
        }}
      >
        <div>
          <div style={styles.modalHeader}>
            <h3 style={styles.modalTitle}>
              {templateType === "promotional" ? (templateForm._id ? "Edit Promotional Template" : "Create New Promotional Template") : (templateForm._id ? "Edit Transactional Template" : "Create New Transactional Template")}
            </h3>
          </div>

          <div style={styles.modalBody}>
            <form onSubmit={this.handleSubmit} style={styles.formContainer}>
              <div style={styles.leftColumn} className="custom-scrollable">
                <div style={styles.formGroup}>
                  <div style={styles.flexRow}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Template ID</label>
                      <input
                        type="text"
                        name="templateId"
                        autoComplete="off"
                        value={templateForm.templateId || ""}
                        onChange={this.handleFormChange}
                        placeholder="Enter template Id"
                        style={Object.assign({}, styles.input, formErrors.templateId ? styles.inputError : {})}
                      />
                    </div>

                    <div style={styles.inputGroup}>
                      <label style={styles.label}>
                        Template Name <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={templateForm.name || ""}
                        onChange={this.handleFormChange}
                        autoComplete="off"
                        placeholder="e.g., Order Confirmation"
                        style={Object.assign({}, styles.input, formErrors.name ? styles.inputError : {})}
                      />
                      {formErrors.name && <p style={styles.errorText}>{formErrors.name}</p>}
                    </div>
                  </div>

                  <div>
                    <label style={styles.label}>
                      Message Content <span style={{ color: "#ef4444" }}>*</span>
                    </label>
                    <textarea
                      name="content"
                      ref={this.messageContentRef}
                      value={templateForm.content || ""}
                      onChange={this.handleFormChange}
                      placeholder="Enter your message template..."
                      rows={6}
                      maxLength={MAX_CHARS}
                      style={Object.assign({}, styles.textarea, formErrors.content ? styles.inputError : {})}
                    />
                    {formErrors.content && <p style={styles.errorText}>{formErrors.content}</p>}
                  </div>

                  {templateType === "transactional" && (
                    <div style={styles.variableBox}>
                      <div style={styles.variableHeader}>
                        <h5 style={styles.sectionTitle}>Variable Mapping</h5>
                        <button
                          type="button"
                          onClick={this.handleAddVariable}
                          style={styles.addButton}
                        >
                          + Add Variable
                        </button>
                      </div>

                      <div>
                        {allVariables.length === 0 && (
                          <p style={{ fontSize: "14px", color: "#6b7280", fontStyle: "italic" }}>
                            No variables detected. Add one or type <code>{"{{1}}"}</code> in content.
                          </p>
                        )}

                        {allVariables.map((varNum) => {
                          const mapping = (templateForm.variableMappings && templateForm.variableMappings[varNum]) 
                            ? templateForm.variableMappings[varNum] 
                            : { type: "dynamic", value: "" };
                          const isDynamic = mapping.type !== "static";
                          
                          return (
                            <div key={varNum} style={styles.variableItem}>
                              <div style={styles.variableRow}>
                                <span
                                  style={styles.variableCode}
                                  onClick={() => this.copyVariableToClipboard(varNum)}
                                  title="Click to copy"
                                >
                                  {`{{${varNum}}}`}
                                </span>
                                {extractedVariables.indexOf(varNum) === -1 && (
                                  <button
                                    type="button"
                                    onClick={() => this.handleRemoveVariable(varNum)}
                                    style={styles.removeButton}
                                  >
                                    remove
                                  </button>
                                )}
                              </div>

                              <div>
                                {isDynamic ? (
                                  <select
                                    style={styles.select}
                                    value={mapping.value || ""}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (val === "ALL_CUSTOM_VALUE") {
                                        this.handleMappingChange(varNum, "type", "static");
                                        this.handleMappingChange(varNum, "value", "");
                                      } else {
                                        this.handleMappingChange(varNum, "type", "dynamic");
                                        this.handleMappingChange(varNum, "value", val);
                                      }
                                    }}
                                  >
                                    <option value="">Select variable key</option>
                                    <option value="ALL_CUSTOM_VALUE" style={{ fontWeight: "600", color: "#2563eb" }}>
                                      ✎ Enter manually the value
                                    </option>
                                    <option disabled style={{ color: "#d1d5db" }}>──────────</option>
                                    {(availableVariables && availableVariables.length > 0 ? availableVariables : []).map((opt) => (
                                      <option key={opt.value} value={opt.value}>{opt.label} ({opt.value})</option>
                                    ))}
                                    {(!availableVariables || availableVariables.length === 0) && (
                                      <option disabled>No variables found for this event</option>
                                    )}
                                  </select>
                                ) : (
                                  <div style={styles.staticInputContainer}>
                                    <input
                                      type="text"
                                      style={styles.staticInput}
                                      placeholder="Enter fixed value"
                                      value={mapping.value || ""}
                                      autoFocus
                                      onChange={(e) => this.handleMappingChange(varNum, "value", e.target.value)}
                                    />
                                    <button
                                      type="button"
                                      onClick={() => {
                                        this.handleMappingChange(varNum, "type", "dynamic");
                                        this.handleMappingChange(varNum, "value", "");
                                      }}
                                      style={styles.clearButton}
                                      title="Switch back to dropdown"
                                    >
                                      <FiX size={16} />
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}

                        {formErrors.variables && (
                          <div style={styles.errorAlert}>
                            <span style={{ marginRight: "8px" }}>⚠️</span>
                            <span>{formErrors.variables}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                   {templateType === "promotional" && (
                    <div style={styles.variableBox}>
                      <div style={styles.variableHeader}>
                        <h5 style={styles.sectionTitle}>Variable Mapping</h5>
                        <button
                          type="button"
                          onClick={this.handleAddVariable}
                          style={styles.addButton}
                        >
                          + Add Variable
                        </button>
                      </div>

                      <div>
                        {allVariables.length === 0 && (
                          <p style={{ fontSize: "14px", color: "#6b7280", fontStyle: "italic" }}>
                            No variables detected. Add one or type <code>{"{{1}}"}</code> in content.
                          </p>
                        )}

                        {allVariables.map((varNum) => {
                          const mapping = (templateForm.variableMappings && templateForm.variableMappings[varNum]) 
                            ? templateForm.variableMappings[varNum] 
                            : { type: "dynamic", value: "" };
                          const isDynamic = mapping.type !== "static";
                          
                          return (
                            <div key={varNum} style={styles.variableItem}>
                              <div style={styles.variableRow}>
                                <span
                                  style={styles.variableCode}
                                  onClick={() => this.copyVariableToClipboard(varNum)}
                                  title="Click to copy"
                                >
                                  {`{{${varNum}}}`}
                                </span>
                                {extractedVariables.indexOf(varNum) === -1 && (
                                  <button
                                    type="button"
                                    onClick={() => this.handleRemoveVariable(varNum)}
                                    style={styles.removeButton}
                                  >
                                    remove
                                  </button>
                                )}
                              </div>

                              <div>
                                {isDynamic ? (
                                  <select
                                    style={styles.select}
                                    value={mapping.value || ""}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (val === "ALL_CUSTOM_VALUE") {
                                        this.handleMappingChange(varNum, "type", "static");
                                        this.handleMappingChange(varNum, "value", "");
                                      } else {
                                        this.handleMappingChange(varNum, "type", "dynamic");
                                        this.handleMappingChange(varNum, "value", val);
                                      }
                                    }}
                                  >
                                    <option value="">Select variable key</option>
                                    <option value="ALL_CUSTOM_VALUE" style={{ fontWeight: "600", color: "#2563eb" }}>
                                      ✎ Enter manually the value
                                    </option>
                                    <option disabled style={{ color: "#d1d5db" }}>──────────</option>
                                    {(availableVariables && availableVariables.length > 0 ? availableVariables : []).map((opt) => (
                                      <option key={opt.value} value={opt.value}>{opt.label} ({opt.value})</option>
                                    ))}
                                    {(!availableVariables || availableVariables.length === 0) && (
                                      <option disabled>No variables found for this event</option>
                                    )}
                                  </select>
                                ) : (
                                  <div style={styles.staticInputContainer}>
                                    <input
                                      type="text"
                                      style={styles.staticInput}
                                      placeholder="Enter fixed value"
                                      value={mapping.value || ""}
                                      autoFocus
                                      onChange={(e) => this.handleMappingChange(varNum, "value", e.target.value)}
                                    />
                                    <button
                                      type="button"
                                      onClick={() => {
                                        this.handleMappingChange(varNum, "type", "dynamic");
                                        this.handleMappingChange(varNum, "value", "");
                                      }}
                                      style={styles.clearButton}
                                      title="Switch back to dropdown"
                                    >
                                      <FiX size={16} />
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}

                        {formErrors.variables && (
                          <div style={styles.errorAlert}>
                            <span style={{ marginRight: "8px" }}>⚠️</span>
                            <span>{formErrors.variables}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {templateType === "promotional" && (
                    <>
                      <div>
                        <label style={styles.label}>Media Type</label>
                        <select
                          name="media.type"
                          value={(templateForm.media && templateForm.media.type) || ""}
                          onChange={this.handleMediaChange}
                          style={Object.assign({}, styles.input, formErrors.mediaType ? styles.inputError : {})}
                        >
                          <option value="">Select media type</option>
                          <option value="image">Image</option>
                          <option value="video">Video</option>
                          <option value="audio">Audio</option>
                          <option value="document">Document</option>
                        </select>
                        {formErrors.mediaType && <p style={styles.errorText}>{formErrors.mediaType}</p>}
                      </div>

                      {isUploading && (
                        <div style={styles.uploadLoader}>
                          Uploading file, please wait...
                        </div>
                      )}

                      {templateForm.media && templateForm.media.type && (
                        <>
                          <div style={styles.mediaUrlRow}>
                            <div style={styles.mediaUrlContainer}>
                              <label style={styles.label}>Media URL</label>
                              <input
                                type="text"
                                name="media.url"
                                value={templateForm.media.url || ""}
                                onChange={this.handleMediaChange}
                                placeholder="Enter media URL"
                                style={Object.assign({}, styles.input, formErrors.mediaUrl ? styles.inputError : {})}
                              />
                              {formErrors.mediaUrl && <p style={styles.errorText}>{formErrors.mediaUrl}</p>}
                            </div>
                            {templateForm.media.url && (
                              <button onClick={this.handleRemoveMedia} style={styles.removeMediaButton}>
                                <FiX size={20} />
                              </button>
                            )}
                            <button
                              type="button"
                              onClick={() => this.fileInputRef.current.click()}
                              style={styles.uploadButton}
                            >
                              <FiUpload />
                              <span>Upload</span>
                              <input
                                type="file"
                                ref={this.fileInputRef}
                                onChange={this.handleFileUpload}
                                style={{ display: "none" }}
                                accept="image/*,video/*,audio/*,.pdf,.doc,.docx"
                              />
                            </button>
                          </div>

                          <div>
                            <label style={styles.label}>Media Filename</label>
                            <input
                              type="text"
                              name="media.filename"
                              value={templateForm.media.filename || ""}
                              onChange={this.handleMediaChange}
                              disabled={!templateForm.media.type || isUploading}
                              placeholder="Enter media filename"
                              style={Object.assign({}, styles.input, formErrors.mediaFilename ? styles.inputError : {})}
                            />
                            {formErrors.mediaFilename && <p style={styles.errorText}>{formErrors.mediaFilename}</p>}
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>

              <div style={styles.rightColumn}>
                <div>
                  <h4 style={styles.previewTitle}>Live Preview</h4>
                  <div style={styles.previewContainer}>
                    <div style={styles.labelBubble}>
                      <p style={styles.labelText}>Your message preview:</p>
                    </div>

                    <div style={styles.previewBubble}>
                      {templateType === "promotional" && templateForm.media && templateForm.media.type && (
                        <div style={styles.mediaPreview}>
                          {templateForm.media.type === "image" && templateForm.media.url && (
                            <img src={templateForm.media.url} alt={templateForm.media.filename} style={styles.image} />
                          )}
                          {templateForm.media.type === "video" && templateForm.media.url && (
                            <video controls style={styles.video} src={templateForm.media.url} />
                          )}
                          {templateForm.media.type === "audio" && templateForm.media.url && (
                            <audio controls style={styles.audio}>
                              <source src={templateForm.media.url} />
                            </audio>
                          )}
                          {templateForm.media.type === "document" && (
                            <div style={styles.documentPreview}>
                              <div style={styles.documentIcon}>
                                {getMediaIcon(templateForm.media.type)}
                              </div>
                              <div style={styles.documentContent}>
                                <p style={styles.documentTitle}>{templateForm.media.filename || "Media attachment"}</p>
                                <p style={styles.documentType}>{templateForm.media.type.toUpperCase()}</p>
                                {templateForm.media.url && (
                                  <a href={templateForm.media.url} target="_blank" rel="noopener noreferrer" style={styles.documentLink}>
                                    View
                                  </a>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {templateForm.content && templateForm.content.length > 0 && (
                        <div style={styles.messageText}>{templateForm.content}</div>
                      )}
                      {(!templateForm.media || !templateForm.media.type) && (!templateForm.content || templateForm.content.length === 0) && (
                        <div style={styles.emptyPreview}>Start typing to see preview...</div>
                      )}
                    </div>
                  </div>
                </div>

                {Object.keys(formErrors).length > 0 && (
                  <div style={styles.errorSummary}>
                    <h4 style={styles.errorSummaryTitle}>Please fix the following issues:</h4>
                    <ul style={styles.errorList}>
                      {Object.values(formErrors).map((msg, idx) => (
                        <li key={idx} style={styles.errorItem}>{msg}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {isUploading && <Spinner />}
            </form>
          </div>

          <div style={styles.modalFooter}>
            <button onClick={onClose} style={styles.cancelButton}>Cancel</button>
            <button onClick={this.handleSubmit} style={styles.saveButton} disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default TemplateFormModal;